// extracted by mini-css-extract-plugin
export var adCard = "_q4-8";
export var adCardBorder = "_q4-5";
export var arbiterButtonIcon = "_q4-p";
export var buttonIcon = "_q4-o";
export var container = "_q4-e";
export var copyButton = "_q4-m";
export var darkGrey = "_q4-u";
export var deliveryDate = "_q4-2";
export var divider = "_q4-n";
export var editModeWrapper = "_q4-7";
export var empty = "_q4-a";
export var errorIcon = "_q4-d";
export var filledCircle = "_q4-4";
export var fulfillmentFooter = "_q4-j";
export var grey = "_q4-s";
export var header = "_q4-i";
export var headerWrapper = "_q4-h";
export var highlighted = "_q4-6";
export var historyEntry = "_q4-3";
export var mobileColumn = "_q4-v";
export var mobileColumnReverse = "_q4-w";
export var orderDetailsContainer = "_q4-g";
export var orderMetadata = "_q4-l";
export var orderMetadataWrapper = "_q4-k";
export var packagesContainer = "_q4-b";
export var product = "_q4-y";
export var productImage = "_q4-z";
export var productInfo = "_q4-x";
export var productTitle = "_q4-10";
export var strikethrough = "_q4-t";
export var tinyText = "_q4-r";
export var title = "_q4-9";
export var trackerCard = "_q4-1";
export var trackerCardWrapper = "_q4-0";
export var trackingContainer = "_q4-f";
export var trackingTitle = "_q4-c";
export var xTinyText = "_q4-q";